import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSuperAdmin } from "./SuperAdminContext";
import SuperAdminLayout from "./SuperAdminLayout";

import OverviewTab from "./tabs/OverviewTab";
import CompaniesTab from "./tabs/CompaniesTab";
import SmtpTab from "./tabs/SmtpTab";
import HealthTab from "./tabs/HealthTab";
import ErrorsTab from "./tabs/ErrorsTab";
import AuditTab from "./tabs/AuditTab";
import SettingsTab from "./tabs/SettingsTab";
import ErrorBoundary from "../../components/ErrorBoundary";

export default function SuperAdminDashboard() {
  const { authenticated, setupComplete, loading } = useSuperAdmin();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab") || "overview";
  const [activeTab, setActiveTab] = useState(tabParam);

  useEffect(() => {
    if (!loading) {
      if (!setupComplete) {
        navigate("/super-admin/setup", { replace: true });
      } else if (!authenticated) {
        navigate("/super-admin/login", { replace: true });
      }
    }
  }, [loading, setupComplete, authenticated, navigate]);

  useEffect(() => {
    const currentTab = searchParams.get("tab") || "overview";
    setActiveTab(currentTab);
  }, [searchParams]);

  const handleSelectTab = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center text-teal-400">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-teal-500 border-t-transparent rounded-full animate-spin" />
          <span className="text-xs font-mono tracking-widest uppercase text-slate-400">
            Connecting to Mission Control...
          </span>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return null;
  }

  return (
    <SuperAdminLayout activeTab={activeTab} onSelectTab={handleSelectTab}>
      <ErrorBoundary>
        {activeTab === "overview" && <OverviewTab onSelectTab={handleSelectTab} />}
        {activeTab === "companies" && <CompaniesTab />}
        {activeTab === "smtp" && <SmtpTab />}
        {activeTab === "health" && <HealthTab />}
        {activeTab === "errors" && <ErrorsTab />}
        {activeTab === "audit" && <AuditTab />}
        {activeTab === "settings" && <SettingsTab />}
      </ErrorBoundary>
    </SuperAdminLayout>
  );
}
